import React from 'react';
import PropTypes from 'prop-types';

const Icon = ({ alt = '', name }) => {
    const path = `/icons/${name}.svg`;

    return (
        <img src={path} alt={alt}/>
    );
};

export default Icon;